import React from "react";
import {
  FaRocket,
  FaGlobe,
  FaBuilding,
  FaStar,
} from "react-icons/fa";

const milestones = [
  {
    year: "2018",
    title: "The Beginning",
    text: "Started as Taksh Education Society, teaching French with a vision to make foreign language learning practical and accessible.",
    icon: <FaRocket />,
  },
  {
    year: "2020",
    title: "Adapting & Evolving",
    text: "Set up first physical premises in Pune and embraced online learning during the pandemic.",
    icon: <FaBuilding />,
  },
  {
    year: "2023",
    title: "A New Identity",
    text: "Evolved into The Lingua Alliance with standardized curricula, certified trainers, and a stronger global vision.",
    icon: <FaStar />,
  },
  {
    year: "Today",
    title: "Global Learning Community",
    text: "A vibrant community serving school students, professionals, and lifelong learners across ages and geographies.",
    icon: <FaGlobe />,
  },
];

export default function RoadmapTimeline() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-white to-[#fbf8ff]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="inline-block mb-4 rounded-full bg-primary/10 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-primary">
            Our Journey
          </span>
          <h2 className="text-3xl sm:text-4xl font-semibold">
            Company History Timeline
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-ink-muted">
            Key milestones that shaped our growth
          </p>
        </div>

        {/* ================= HORIZONTAL TIMELINE ================= */}
        <div className="relative overflow-x-auto pb-14 py-14">
          <div className="relative flex min-w-max px-4  ">
            {/* Center line */}
            <div className="absolute left-0 right-0 top-1/2 h-[2px] -translate-y-1/2 bg-gradient-to-r from-primary/20 via-primary/50 to-primary/20" />

            {milestones.map((item, index) => {
              const isTop = index % 2 === 0;

              return (
                <div
                  key={item.year}
                  className="relative w-[300px] h-[380px] flex flex-col items-center justify-center"
                >
                  {/* TOP CARD */}
                  {isTop && (
                    <div className="absolute top-[-36px] flex flex-col items-center">
                      <TimelineCard item={item} />
                      <Connector />
                    </div>
                  )}

                  {/* CENTER DOT + YEAR */}
                  <div className="relative z-10 flex flex-col items-center">
                    {isTop && <div className="w-4 h-4 rounded-full bg-primary shadow-md" />}
                    <span className={`${isTop ? "mt-3" : "mb-4"} text-xs font-semibold text-primary`}>
                      {item.year}
                    </span>
                    {!isTop && <div className="w-4 h-4 rounded-full bg-primary shadow-md" />}
                  </div>

                  {/* BOTTOM CARD */}
                  {!isTop && (
                    <div className="absolute bottom-[-36px] flex flex-col items-center">
                      <Connector />
                      <TimelineCard item={item} />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================= SUB COMPONENTS ================= */

function Connector() {
  return (
    <div className="h-10 w-px bg-primary/30" />
  );
}

function TimelineCard({ item }) {
  return (
    <div className="min-w-[260px] min-h-[160px] rounded-2xl bg-gradient-to-br from-slate-100 to-slate-200 border-primary/10 p-5 shadow-md hover:shadow-xl transition">
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
        {item.icon}
      </div>
      <h3 className="text-sm font-semibold mb-1">{item.title}</h3>
      <p className="text-xs text-ink-muted leading-relaxed">
        {item.text}
      </p>
    </div>
  );
}
